import { render } from "./ResolveButton.vue?vue&type=template&id=4c5f8912&scoped=true"
import script from "./ResolveButton.vue?vue&type=script&lang=js"
export * from "./ResolveButton.vue?vue&type=script&lang=js"

import "./ResolveButton.vue?vue&type=style&index=0&id=4c5f8912&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5f8912"]])

export default __exports__